module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_06_travel-bd20fcf3659fbc4032953366637af188.jpg";